import React from 'react';
import './Button.css';


interface ButtonProps {
    type: string;
    name: string;
    width?: string;
    link?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    icon?: React.ReactNode;
    className?: string;
}
const LOGIN_TYPE = 'login';

const Button: React.FC<ButtonProps> = ({ type, name, width, link = '', onClick, icon, className = '' }) => {

    const baseClass = type === LOGIN_TYPE ? 'login-type' : 'register-type';

    const finalClassName = `${baseClass} ${className}`.trim();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (type === LOGIN_TYPE) {
            event.preventDefault();
            if (link !== '') {
                window.location.href = link;
            }
            if (onClick) {
                onClick(event);
            }
        } else {
            if (link !== '') {
                window.location.href = link;
            }
        }
    };

    return (
        <div className="container-button">
            <button className={finalClassName} type="button" onClick={handleClick}>
                {icon && <span className="button-icon">{icon}</span>}
                {name}
            </button>
        </div>
    );
};

export default Button;